export const QUERY_ORGANIZATION = /* GraphQL */ `
  query getOrganization($id: ID!) {
    organization(id: $id) {
      id
      onlineContributionConfiguration {
        id
        active
        name
        sellerId
        publicOnlineDonationUrl
        documentType
        documentNumber
        boletoFixedCharge
        statusGateway
        bankAccount {
          bankAccountType
          agency
          number
          bank {
            id
            code
          }
        }
        gatewayPlans {
          collection {
            name
            active
          }
        }
      }
    }

    banks {
      collection {
        id
        code
        bankName
      }
    }
  }
`
